import React from 'react';
import ReactDOM from 'react-dom';

//component
import DraftsScreen from  '@/components/page/Content/Drafts/DraftsScreen';

const AllUserGroupsPortal = () => { 


    const targetContainer = document.getElementById('react-drafts-content-container');
    let appId
    
    if (!targetContainer) {
        return null;
    } else {
      appId = targetContainer.getAttribute('data-app-id');
    }

    return ReactDOM.createPortal(
      <DraftsScreen appId={appId} />, targetContainer
    );
}


export default AllUserGroupsPortal;